export enum ROUTES {
  HOME = '/',
  CATEGORY = '/category',
  ADDITEM = '/add-item',
  DETAILS = '/details',
  ITEMDETAILS = '/item-details',
  CART = '/cart',
  PAYMENT = '/payment',
  OTP = '/otp',
  CONTACTUS = '/contact-us',
  FAQ = '/faq',
  ABOUT = '/about',
  PRIVACYPOLICY = '/privacy-policy',
  RECEIPT = '/receipt',
  REVIEWS = '/reviews',
  SCAN = '/scan',
  ORDERDETAILS = '/order-details',
  PHONEVERIFY = '/phone-verifiy',
  TERMSCONDITIONS = '/terms-conditions',
}
